import type { ProcedureAssignedTo, ProcedureJourneyStep } from '@/types/cgt'

/**
 * Client-side twin of the backend derivation: the procedure-level Assign To is
 * never stored, only computed from the per-form assignments. Every form the
 * same user → that user; anything mixed or partial → multiple; none → none.
 */
export function deriveProcedureAssignedTo(steps: ProcedureJourneyStep[]): ProcedureAssignedTo {
  const assigned = steps.filter(s => s.assignee != null)
  if (assigned.length === 0) return { kind: 'none' }
  const first = assigned[0].assignee!
  const uniform = assigned.every(s => s.assignee!.id === first.id)
  if (uniform && assigned.length === steps.length) return { kind: 'user', user: first }
  return { kind: 'multiple' }
}

export function assignedToLabel(assignedTo: ProcedureAssignedTo | undefined): string {
  if (!assignedTo || assignedTo.kind === 'none') return 'Unassigned'
  if (assignedTo.kind === 'multiple') return 'Multiple'
  return assignedTo.user.name
}

/** Compact initials for the per-form assignee chip ("Jane Doe" → "JD"). */
export function assigneeInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map(w => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}
